interface UserData {
  firstName?: string;
  middleName?: string;
  lastName?: string;
  emailAddress?: string;
  username?: string;
  password?: string;
  confirmPassword?: string;
}
    
interface FormValidation {
  postData: UserData;
  getAllUsers?: UserData[];
}
  
const userValidateFirstName = ({ postData }: FormValidation) => {
  const errors: string[] = [];
  let isValid = false;

  if (!postData.firstName || postData.firstName.trim() === '') {
    errors.push('First name cannot be empty');
    isValid = false;
  } else if (postData.firstName.length < 2) {
    errors.push('First name must be at least 2 letters');
    isValid = true;
  } else if (!/^[a-zA-Z]+$/.test(postData.firstName)) {
    errors.push('First name must contain only letters and no whitespaces');
    isValid = true;
  }
  return { isValid, errors };
};

const userValidateMiddleName = ({ postData }: FormValidation) => {
  const errors: string[] = [];
  let isValid = false;

  if (!postData.firstName || postData.firstName.trim() === '') {
    errors.push('Middle name cannot be empty');
    isValid = false;
  } else if (postData.firstName.length < 2) {
    errors.push('Middle name must be at least 2 letters');
    isValid = true;
  } else if (!/^[a-zA-Z]+$/.test(postData.firstName)) {
    errors.push('Middle name must contain only letters and no whitespaces');
    isValid = true;
  }
  return { isValid, errors };
};

const userValidateLastName = ({ postData }: FormValidation) => {
  const errors: string[] = [];
  let isValid = false;

  if (!postData.lastName || postData.lastName.trim() === '') {
    errors.push('Last name cannot be empty');
    isValid = false;
  } else if (postData.lastName.length < 2) {
    errors.push('Last name must be at least 2 letters');
    isValid = true;
  } else if (!/^[a-zA-Z]+$/.test(postData.lastName)) {
    errors.push('Last name must contain only letters and no whitespaces');
    isValid = true;
  }
  return { isValid, errors };
};
  
const userValidateEmailAddress = ({ postData, getAllUsers }: FormValidation) => {
  const errors: string[] = [];
  let isValid = false;
  const emailRegex = /^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/;

  if (!postData.emailAddress || postData.emailAddress.trim() === '') {
    errors.push('Email address cannot be empty');
    isValid = false;
  } else if (getAllUsers && getAllUsers.some(user => user.emailAddress === postData.emailAddress)) {
    errors.push('Email address already exist');
    isValid = true;
  } else if (!emailRegex.test(postData.emailAddress)) {
    errors.push('Invalid email address');
    isValid = true;
  }
  return { isValid, errors };
};
  
const userValidateUsername = ({ postData, getAllUsers }: FormValidation) => {
  const errors: string[] = [];
  let isValid = false;

  if (!postData.username || postData.username.trim() === '') {
    errors.push('Username cannot be empty');
    isValid = false;
  } else if (getAllUsers && getAllUsers.some(user => user.username === postData.username)) {
    errors.push('Username already exist');
    isValid = true;
  } else if (postData.username.length < 6) {
    errors.push('Username must be at least 6 characters long');
    isValid = true;
  }
  return { isValid, errors };
};
  
const userValidatePassword = ({ postData }: FormValidation) => {
  const errors: string[] = [];
  let isValid = false;
  // const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-_]).{7,}$/;
  const passwordRegex = /^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-_]).{7,}$/;

  if (!postData.password || postData.password.trim() === '') {
    errors.push('Password cannot be empty');
    isValid = false;
  } else if (!passwordRegex.test(postData.password)) {
    // ('Password must be at least 7 characters long, contain one uppercase letter, and one number');
    errors.push('Password must be at least 7 characters long and one number');
    isValid = true;
  } else if (postData.password.includes(' ')) {
    errors.push('Password cannot contain spaces');
    isValid = true;
  }
  return { isValid, errors };
};
  
const userValidateConfirmPassword = ({ postData }: FormValidation) => {
  const errors: string[] = [];
  let isValid = false;

  if (!postData.confirmPassword || postData.confirmPassword.trim() === '') {
    errors.push('Confirm password cannot be empty');
    isValid = false;
  } else if (postData.password !== postData.confirmPassword) {
    errors.push('Passwords do not match');
    isValid = true;
  }
  return { isValid, errors };
};

export{
  userValidateFirstName,
  userValidateMiddleName,
  userValidateLastName,
  userValidateEmailAddress,
  userValidateUsername,
  userValidatePassword,
  userValidateConfirmPassword,
}